import React, { useEffect, useState } from 'react'
import './Contact.css'
import { Link } from 'react-router-dom'
import Email_icon from '../../assests/Frame 18 (8).png'
import Phone_icon from '../../assests/Frame 19.png'
import Location_icon from '../../assests/Frame 20@2x.png'
import Box_icon from '../../assests/Frame 21.png'
import { TiSocialFacebook } from "react-icons/ti";
import { IoLogoTwitter } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FORMSPREE_ENDPOINT } from '../../config/formspree';

const Contact = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [form, setForm] = useState({ email: '', message: '' });
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768 && !isSmallScreen) {
        setIsSmallScreen(true);
      } else if (window.innerWidth >= 768 && isSmallScreen) {
        setIsSmallScreen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isSmallScreen]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...form, _subject: 'Contact Form — Sendcheap' }),
      });
      const data = await res.json();
      if (data.ok) {
        setStatus('success');
        setForm({ email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className='contact'>
      <div className="contact-container">
        <div className="contact-top">
          <div className="contact-top_1">
            <div className="top_1-header">
              <div className="contact-badge">
                <p>Contact</p>
              </div>
              <h2>Let's stay connected</h2>
              <div className="header-text">
                <p>
                  It's never been easier to get in touch with SendCheap. Call us, use our live chat widget or email and we'll get back to you as soon as possible!
                </p>
              </div>
            </div>
            <div className="top_1-buttons">
              <Link to='/about-us'>
                <button className="top-btn-2">About Us</button>
              </Link>
            </div>
          </div>

          <div className="contact-top_2">
            <div className="top_2-left">
              <div className="contact-info">
                <img src={Email_icon} alt="" />
                <h4>Email</h4>
                <p><a href="mailto:business@sendcheap.ng" target='_blank' rel="noreferrer">business@sendcheap.ng</a></p>
              </div>
              <div className="contact-info">
                <img src={Phone_icon} alt="" />
                <h4>Phone</h4>
                <p><a href="tel:+234-701-7215143" target='_blank' rel="noreferrer">+234-701-7215143</a></p>
              </div>
              <div className="contact-info">
                <img src={Location_icon} alt="" />
                <h4>Office</h4>
                <p>No 20B Tayo Kehinde Egbeda <br /> Lagos State, Nigeria.</p>
              </div>
              <div className="contact-info">
                <img src={Box_icon} alt="" />
                <h4>Socials</h4>
                <div className="contact-social-icons">
                  <a href="https://web.facebook.com/sendcheap/" target="_blank" rel="noreferrer"><TiSocialFacebook className='contact-icon' /></a>
                  <a href="https://x.com/sendcheap_Ltd?t=udHylxjoUok31nLRwzAE3g&s=09" target="_blank" rel="noreferrer"><IoLogoTwitter className='contact-icon' /></a>
                  <a href="https://www.instagram.com/reel/DXyqOWvsRGB/" target="_blank" rel="noreferrer"><FaInstagram className='contact-icon' /></a>
                  <a href="#"><FaLinkedin className='contact-icon' /></a>
                </div>
              </div>
            </div>

            <div className="contact-top-2-right">
              <div className="contact-top-2-container">
                {status === 'success' ? (
                  <div className="form-success-state">
                    <div className="form-success-icon">✓</div>
                    <h3>Message sent!</h3>
                    <p>We'll get back to you within 24 hours.</p>
                    <button className="btn-form" onClick={() => setStatus('idle')}>Send another</button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-container">
                      <label>Email</label>
                      <input
                        type='email'
                        name='email'
                        placeholder="debs@sendcheap.cash"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-container">
                      <label>Message</label>
                      <textarea
                        name='message'
                        cols="50"
                        rows="10"
                        placeholder='Your message'
                        value={form.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {status === 'error' && (
                      <p className="form-error-msg">Something went wrong. Please try again.</p>
                    )}
                    <div className="form-btn">
                      <button
                        className='btn-form'
                        type='submit'
                        disabled={status === 'submitting'}
                        style={{ cursor: status === 'submitting' ? 'not-allowed' : 'pointer' }}
                      >
                        {status === 'submitting' ? 'Sending…' : 'Send'}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
